<form [formGroup]="formGroup()">
  <input
    type="file"
    class="file-input"
    [accept]="accept()"
    #fileInput
    (change)="onFileSelected($event)" />
  <div class="fileUploadContainer">
    <div class="file-upload">
      <div class="filename">
        {{ this.file.name || 'No file selected' }}
        @if(file && file.size){
        {{ this.file.size | convertToBytes }}
        }
      </div>
      <div class="file-buttons">
        <button
          mat-mini-fab
          color="primary"
          class="uploadBTN"
          (click)="fileInput.click()"
          matTooltip="Upload file">
          <mat-icon>attach_file</mat-icon>
        </button>

        @if(showUploadBtn()){
        <button
          mat-raised-button
          (click)="uploadAttachment()">
          Upload file
        </button>
        }
      </div>
    </div>
  </div>
</form>
